module.exports = __webpack_public_path__ + "static/media/confianza.2c7511dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/confianza.svg
// module id = 198
// module chunks = 0